(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './androidx-lifecycle-lifecycle-viewmodel.js', './kotlin-kotlin-stdlib.js', './projects-core-koin-core.js', './androidx-lifecycle-lifecycle-viewmodel-savedstate.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./androidx-lifecycle-lifecycle-viewmodel.js'), require('./kotlin-kotlin-stdlib.js'), require('./projects-core-koin-core.js'), require('./androidx-lifecycle-lifecycle-viewmodel-savedstate.js'));
  else {
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core-viewmodel'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel' is loaded prior to 'projects-core-koin-core-viewmodel'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core-viewmodel'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'projects-core-koin-core-viewmodel'.");
    }
    if (typeof globalThis['projects-core-koin-core'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core-viewmodel'. Its dependency 'projects-core-koin-core' was not found. Please, check whether 'projects-core-koin-core' is loaded prior to 'projects-core-koin-core-viewmodel'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core-viewmodel'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel-savedstate' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel-savedstate' is loaded prior to 'projects-core-koin-core-viewmodel'.");
    }
    globalThis['projects-core-koin-core-viewmodel'] = factory(typeof globalThis['projects-core-koin-core-viewmodel'] === 'undefined' ? {} : globalThis['projects-core-koin-core-viewmodel'], globalThis['androidx-lifecycle-lifecycle-viewmodel'], globalThis['kotlin-kotlin-stdlib'], globalThis['projects-core-koin-core'], globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate']);
  }
}(function (_, kotlin_androidx_lifecycle_lifecycle_viewmodel, kotlin_kotlin, kotlin_io_insert_koin_koin_core, kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate) {
  'use strict';
  //region block: imports
  var Empty_getInstance = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.h;
  var HasDefaultViewModelProviderFactory = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.a;
  var isInterface = kotlin_kotlin.$_$.rg;
  var VOID = kotlin_kotlin.$_$.d;
  var Companion_getInstance = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.i;
  var KoinPlatformTools_instance = kotlin_io_insert_koin_koin_core.$_$.b;
  var ParametersHolder = kotlin_io_insert_koin_koin_core.$_$.l;
  var toMutableList = kotlin_kotlin.$_$.pc;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var protoOf = kotlin_kotlin.$_$.eh;
  var createSavedStateHandle = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var SavedStateHandle = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.b;
  var getKClass = kotlin_kotlin.$_$.si;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var generateId = kotlin_io_insert_koin_koin_core.$_$.p;
  var TypeQualifier = kotlin_io_insert_koin_koin_core.$_$.n;
  var hasViewModelScopeFactory = kotlin_io_insert_koin_koin_core.$_$.k;
  var Factory = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.c;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var ViewModel = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.e;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(AndroidParametersHolder, 'AndroidParametersHolder', VOID, ParametersHolder);
  initMetadataForClass(KoinViewModelFactory, 'KoinViewModelFactory', VOID, VOID, [Factory]);
  initMetadataForClass(ViewModelScopeAutoCloseable, 'ViewModelScopeAutoCloseable', VOID, VOID, [AutoCloseable]);
  //endregion
  function defaultExtras(viewModelStoreOwner) {
    var tmp;
    if (isInterface(viewModelStoreOwner, HasDefaultViewModelProviderFactory)) {
      tmp = viewModelStoreOwner.y8p();
    } else {
      tmp = Empty_getInstance();
    }
    return tmp;
  }
  function resolveViewModel(vmClass, viewModelStore, key, extras, qualifier, scope, parameters) {
    key = key === VOID ? null : key;
    qualifier = qualifier === VOID ? null : qualifier;
    parameters = parameters === VOID ? null : parameters;
    var factory = new KoinViewModelFactory(vmClass, scope, qualifier, parameters);
    var provider = Companion_getInstance().i8r(viewModelStore, factory, extras);
    var className = KoinPlatformTools_instance.ys6(vmClass);
    var vmKey = getViewModelKey(qualifier, key, className);
    return !(vmKey == null) ? provider.l8r(vmKey, vmClass) : provider.k8r(vmClass);
  }
  function getViewModelKey(qualifier, key, className) {
    qualifier = qualifier === VOID ? null : qualifier;
    key = key === VOID ? null : key;
    className = className === VOID ? null : className;
    var tmp;
    if (!(key == null)) {
      tmp = key;
    } else if (!(qualifier == null)) {
      var tmp_0 = qualifier.u1();
      var tmp_1;
      if (className == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = '_' + className;
      }
      var tmp1_elvis_lhs = tmp_1;
      tmp = tmp_0 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function AndroidParametersHolder(initialValues, extras) {
    initialValues = initialValues === VOID ? null : initialValues;
    var tmp1_safe_receiver = initialValues == null ? null : initialValues();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.y2();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toMutableList(tmp2_safe_receiver);
    var tmp;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = tmp3_elvis_lhs;
    }
    ParametersHolder.call(this, tmp);
    this.oxb_1 = extras;
  }
  protoOf(AndroidParametersHolder).ws5 = function (i, clazz) {
    // Inline function 'org.koin.viewmodel.factory.AndroidParametersHolder.createSavedStateHandleOrElse' call
    var tmp;
    if (clazz.equals(getKClass(SavedStateHandle))) {
      var tmp_0 = createSavedStateHandle(this.oxb_1);
      tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
    } else {
      tmp = protoOf(ParametersHolder).ws5.call(this, i, clazz);
    }
    return tmp;
  };
  protoOf(AndroidParametersHolder).xs5 = function (clazz) {
    // Inline function 'org.koin.viewmodel.factory.AndroidParametersHolder.createSavedStateHandleOrElse' call
    var tmp;
    if (clazz.equals(getKClass(SavedStateHandle))) {
      var tmp_0 = createSavedStateHandle(this.oxb_1);
      tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
    } else {
      tmp = protoOf(ParametersHolder).xs5.call(this, clazz);
    }
    return tmp;
  };
  function getViewModelScopeId($this, modelClass) {
    return '' + modelClass.o() + '-' + generateId(KoinPlatformTools_instance);
  }
  function KoinViewModelFactory(kClass, scope, qualifier, params) {
    qualifier = qualifier === VOID ? null : qualifier;
    params = params === VOID ? null : params;
    this.pxb_1 = kClass;
    this.qxb_1 = scope;
    this.rxb_1 = qualifier;
    this.sxb_1 = params;
  }
  protoOf(KoinViewModelFactory).e8r = function (modelClass, extras) {
    var androidParams = new AndroidParametersHolder(this.sxb_1, extras);
    var koin = this.qxb_1.vs6();
    var tmp;
    if (!hasViewModelScopeFactory(koin.is2_1)) {
      tmp = this.qxb_1.us6(this.pxb_1, this.rxb_1, androidParams);
    } else {
      var scopeId = getViewModelScopeId(this, modelClass);
      var vmScope = koin.js2(scopeId, new TypeQualifier(modelClass), null, get_ViewModelScopeArchetype());
      var vm = vmScope.us6(this.pxb_1, this.rxb_1, androidParams);
      vm.p8q(new ViewModelScopeAutoCloseable(scopeId, koin));
      tmp = vm;
    }
    return tmp;
  };
  function ViewModelScopeAutoCloseable(scopeId, koin) {
    this.txb_1 = scopeId;
    this.uxb_1 = koin;
  }
  protoOf(ViewModelScopeAutoCloseable).j4 = function () {
    this.uxb_1.ps2(this.txb_1);
  };
  function get_ViewModelScopeArchetype() {
    _init_properties_ViewModelScopeArchetype_kt__smac8p();
    return ViewModelScopeArchetype;
  }
  var ViewModelScopeArchetype;
  var properties_initialized_ViewModelScopeArchetype_kt_st5lxl;
  function _init_properties_ViewModelScopeArchetype_kt__smac8p() {
    if (!properties_initialized_ViewModelScopeArchetype_kt_st5lxl) {
      properties_initialized_ViewModelScopeArchetype_kt_st5lxl = true;
      ViewModelScopeArchetype = new TypeQualifier(getKClass(ViewModel));
    }
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = defaultExtras;
  _.$_$.b = resolveViewModel;
  //endregion
  return _;
}));

//# sourceMappingURL=projects-core-koin-core-viewmodel.js.map
